import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Tag } from '~/components';

interface Option {
  label: string;
  value: string;
}

interface FilterChipsProps {
  options: Option[];
  path: string;
}

export function FilterChips({ options, path }: FilterChipsProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeOption, setActiveOption] = useState<string>(
    () => searchParams.get(path) || 'all',
  );

  const handleOptionClick = (selected: string) => {
    setActiveOption(selected);

    const params = new URLSearchParams(searchParams);

    if (selected === 'all') {
      params.delete(path);
    } else {
      params.set(path, selected);
    }

    setSearchParams(params);
  };

  useEffect(() => {
    const paramValue = searchParams.get(path) || 'all';

    setActiveOption((prev) => {
      if (prev === paramValue) {
        return prev;
      }

      return paramValue;
    });
  }, [activeOption, path, searchParams]);

  return (
    <ul className="flex cursor-pointer flex-wrap gap-sm">
      {options.map((choice) => (
        <Tag
          asChild
          key={choice.value}
          variant={activeOption === choice.value ? 'active' : 'secondary'}
          size="lg"
          onClick={() => handleOptionClick(choice.value)}
          data-testid={activeOption === choice.value ? 'activeChip' : ''}
        >
          <li>{choice.label}</li>
        </Tag>
      ))}
    </ul>
  );
}

FilterChips.displayName = 'FilterChips';
